import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from 'src/app/common/services/authentication.service';
import { ClientssoService } from 'src/app/common/services/clientsso.service';
import { environment } from 'src/app/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  apiBaseUrl = environment.baseApiUrl;

  constructor(
    private clientSsoService: ClientssoService,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.logintoKantar();
  }

  logintoKantar() {
    this.clientSsoService.loginWithAzureAD();
  }
}
